module.exports = __webpack_public_path__ + "static/media/tree.4de11aa2.png";